import { Arrow } from 'shared/icons/Arrow';

export const ScrollToTopArrow = ({ onCustomClick }: any) => {
  const handleClick = () => {
    if (onCustomClick) {
      onCustomClick();
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button type="button" onClick={handleClick} aria-label="Scroll to top" data-qa="scroll_to_top">
      <Arrow />
    </button>
  );
};
